import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {FieldsInterventionsPageComponent } from './fields-interventions-page.component';
import {TabModule} from '../../tab/tab.module';
import {FieldsInterventionsToolbarModule} from '../fields-interventions-toolbar/fields-interventions-toolbar.module';
import {FieldsInterventionsGridModule} from '../fields-interventions-grid/fields-interventions-grid.module';

import {FieldsInterventionsDashboardModule} from '../fields-interventions-dashboard/fields-interventions-dashboard.module';
import {FieldsInterventionsPivotGridModule} from '../fields-interventions-pivot-grid/fields-interventions-pivot-grid.module';
import {FieldsInterventionsSettingsModule} from '../fields-interventions-settings/fields-interventions-settings.module';


@NgModule({
  declarations: [FieldsInterventionsPageComponent],
  imports: [
    CommonModule,
    TabModule,
    FieldsInterventionsToolbarModule,
    FieldsInterventionsGridModule,
    FieldsInterventionsDashboardModule,
    FieldsInterventionsPivotGridModule,
    FieldsInterventionsSettingsModule
  ],
  exports: [FieldsInterventionsPageComponent]
})
export class FieldsInterventionsPageModule { }
